import { render } from "./SimpleClock.vue?vue&type=template&id=715d088e&scoped=true"
import script from "./SimpleClock.vue?vue&type=script&lang=js"
export * from "./SimpleClock.vue?vue&type=script&lang=js"

import "./SimpleClock.vue?vue&type=style&index=0&id=715d088e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715d088e"]])

export default __exports__